<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <button mat-icon-button (click)="goBack()" class="back-btn">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Grupos</span>
  <span class="spacer"></span>
  <button mat-icon-button (click)="createGroup()" title="Nuevo grupo">
    <mat-icon>add</mat-icon>
  </button>
</mat-toolbar>

<div class="grp-wrapper">
  <!-- Search -->
  <div class="grp-search">
    <mat-icon class="grp-search__icon">search</mat-icon>
    <input
      class="grp-search__input"
      type="text"
      placeholder="Buscar participante…"
      [(ngModel)]="searchQuery"
    />
    @if (searchQuery) {
      <button class="grp-search__clear" (click)="searchQuery = ''">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  @if (groups && groups.length) {
    <!-- Filter chips -->
    <div class="grp-legend">
      <button
        class="grp-legend__pill"
        [class.active]="activeFilter === 'NOGROUP'"
        (click)="setFilter('NOGROUP')"
      >
        Sin grupo
      </button>
      @for (group of groups; track group) {
        <button
          class="grp-legend__pill"
          [class.active]="activeFilter === group._id"
          (click)="setFilter(group._id)"
        >
          {{ group.name }}
        </button>
      }
    </div>
  }

  <!-- Flat user list -->
  <div class="grp-list">
    @for (user of filteredUsers; track user) {
      <div class="grp-card">
        <div class="grp-card__avatar">
          <app-avatar [user]="user"></app-avatar>
        </div>
        <div class="grp-card__info">
          <span class="grp-card__name">{{ user.name }}</span>
          <div class="grp-card__chips">
            @for (group of groups; track group) {
              <button
                class="grp-chip"
                [class.active]="isInGroup(user, group._id)"
                (click)="toggleGroup(user, group._id)"
              >
                {{ group.name }}
              </button>
            }
          </div>
        </div>
      </div>
    }
    @if (filteredUsers.length === 0) {
      <div class="grp-empty">
        <div class="grp-empty__icon">👥</div>
        <p class="grp-empty__title">
          @if (activeFilter === "NOGROUP") {
            Todos tienen grupo asignado
          } @else if (activeFilter) {
            Ningún participante en este grupo
          } @else if (searchQuery) {
            Sin resultados para "{{ searchQuery }}"
          } @else {
            Aún no hay participantes
          }
        </p>
        <p class="grp-empty__sub">
          @if (activeFilter || searchQuery) {
            Prueba con otro filtro o búsqueda
          } @else {
            Añade participantes desde el panel de usuarios
          }
        </p>
      </div>
    }
  </div>
</div>

<block-ui></block-ui>
